module.exports = __webpack_public_path__ + "img/150.d5ece7d4.jpg";